var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-fade" }, [
    _c("p", { staticClass: "login-title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("p", { staticClass: "login-subtitle" }, [
      _vm._v("\n    " + _vm._s(_vm.subTitle) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login" }, [
      _c("div", { staticClass: "circle" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "45",
              height: "32",
              viewBox: "0 0 45 32",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("path", {
              attrs: {
                d: "M43.4768 1.12891L14.3472 30.4622L1.10645 17.1289",
                stroke: "#1AB26B",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "login-submit outer", on: { click: _vm.loginClose } },
      [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }